import React, { useEffect, useState } from "react";
import { getActiveModule } from "@/ts/utils";
import { FaDownload } from "react-icons/fa";
import { ParentModule, TExportGridBtnProps } from "@/ts/common-types";
import { usePermissionCheck } from "@/hooks/AllCustomHooks";
import { Button } from "antd";

const ExportGridBtn = ({
    onClickFunction,
    isSubModule,
    className,
}: TExportGridBtnProps) => {
    const { canExport } = usePermissionCheck();

    const { activeModule } = getActiveModule();

    const [displayGridExportBtn, setDisplayExportGridBtn] = useState(false);

    useEffect(() => {
        setDisplayExportGridBtn(
            canExport &&
                (isSubModule ||
                    activeModule ===
                        (ParentModule.PRODUCT_ANALYTICS as string) ||
                    activeModule ===
                        (ParentModule.KEYWORD_ANALYTICS as string) ||
                    activeModule === (ParentModule.NEGATIVE_KEYWORDS as string))
        );
    }, [canExport, activeModule]);

    return (
        <Button
            className={`btn btn-sm btn-dark ${
                className
                    ? className
                    : isSubModule
                    ? "ms-auto mx-3 my-1"
                    : "ms-1 me-2"
            } ${displayGridExportBtn ? "d-block" : "d-none"}`}
            onClick={() => onClickFunction()}
        >
            <FaDownload /> Export
        </Button>
    );
};

export default ExportGridBtn;